//import logo from './logo.svg';
//import './App.css';
import React, {useEffect} from 'react';
import {getUsers} from '../actions/users'
import ReactDOM from 'react-dom'
//import {Container, AppBar, Typography, Grow, Grid} from '@material-ui/core';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import MyLink from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Button from '@mui/material/Button';
import ChartsEmbedSDK from "@mongodb-js/charts-embed-dom";
import Card from '@mui/material/Card';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import Moment from 'moment'
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { mainListItems, secondaryListItems } from '../listItems';

import LineChart from '../lineChart';
import UserList from '../userList';
import Odors from '../odorTracker';
import MapDevice from '../mapDevice';
//import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { toast } from 'react-toastify'
import { createProject, reset,getProjects } from '../features/projects/projectSlice'
import {getMapDevices,createDevices,editDevices,getDevices} from '../features/devices/deviceSlice'

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';


import Legend from '../Legend';
import logo from '../logos/JustAirLogo1.png'
import {useDispatch, useSelector} from 'react-redux'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useNavigate
} from "react-router-dom";

//import memories from './memories.png'

import useStyles from '../styles'

const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#29ABE2',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});


const EditDevice  = () => {

  const dispatch = useDispatch();




  const { project, isLoading, isError, isSuccess,isDeviceSuccess ,message,isEditDeviceSuccess } = useSelector(
    (state) => state.device
  )

  useEffect(() => {
    if (isError) {
      toast.error(message)
    }

    if (isEditDeviceSuccess) {
      navigate('/admin')
    }

    dispatch(reset())
  }, [project, isError, isSuccess, message, navigate, dispatch,isDeviceSuccess,isEditDeviceSuccess])

  let navigate = useNavigate();


function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <MyLink color="inherit" href="https://justair.co/" target="_blank">
        JustAir Solutions
      </MyLink>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

const mdTheme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#1572A1',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});;


  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    setOpen(!open);
  };




const [personName, setPersonName] = React.useState([]);
const editDeviceData = JSON.parse(localStorage.getItem('deviceEdit'))

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};


const [value, setValue] = React.useState('Controlled')
const [timeValue, setTimeValue] = React.useState(new Date());
const [timeValue2, setTimeValue2] = React.useState(new Date());




 const [deviceData, setDeviceData] = React.useState({
   deviceName:editDeviceData.device_ID,
   active:editDeviceData.active,
   _id:editDeviceData._id,
 })

 const { deviceName, active } = deviceData






const onChange = (e) => {
  setDeviceData((prevState) => ({
    ...prevState,
    [e.target.name]: e.target.value,
  }))
}



const onSubmit = (e) => {
  e.preventDefault()

  if (deviceData.deviceName.length >0){
    const devData = {
       deviceName: deviceData.deviceName,
       active:deviceData.active,
       _id:editDeviceData._id

     }
     console.log(devData)
       dispatch(editDevices(devData))

  }



}


  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="absolute" open={open}>
          <Toolbar
            sx={{
              pr: '24px', // keep right padding when drawer closed
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                marginRight: '36px',
                ...(open && { display: 'none' }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="white"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              EcologyAir Test
            </Typography>


          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <Toolbar
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              px: [1],
            }}
          >
            <IconButton onClick={toggleDrawer}>
              <ChevronLeftIcon />
            </IconButton>
          </Toolbar>
          <Divider />
          <List>{mainListItems}</List>
          <Divider />

        </Drawer>
        <Box   justifyContent="center"
        alignItems="center"
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >

          <Toolbar />




          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
            component="form" noValidate   onSubmit={onSubmit}
          >

        <Paper sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }} variant="outlined">


    <Grid container  alignItems="center"  justifyContent="center" spacing={3} xs={12} md={12} lg={12}  direction="row">

      <Grid item xs={12} sm={8}>
        <Typography variant="h6" gutterBottom>
          Edit Device
         </Typography>

          <TextField
           required
           id="deviceName"
           name="deviceName"
           label="Device Name"
            defaultValue={editDeviceData.device_ID}
           fullWidth
           onChange={onChange}
           variant="standard"
          />

          <Grid item xs={12}>

       <FormControl sx={{ m: 1, minWidth: 80 }}>
        <FormLabel >Device Active</FormLabel>

          <InputLabel id="demo-simple-select-autowidth-label"></InputLabel>
          <Select
            labelId="demo-simple-select-autowidth-label"
            id="demo-simple-select-autowidth"
            onChange={onChange}
            defaultValue={editDeviceData.active}
            name="active"
            fullWidth
            label="deviceActive"
          >

            <MenuItem value={true}>Active</MenuItem>
            <MenuItem value={false}>Not Active</MenuItem>


          </Select>
        </FormControl>


     </Grid>


                    <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    >
                    Edit Device
                    </Button>




      </Grid>
        <Grid item xs={12}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
              <Copyright sx={{ pt: 4 }} />
          </Paper>
            </Grid>
          </Grid>
            </Paper>
          </Box>
        </Box>
      </Box>



    </ThemeProvider>
  );



}


export default EditDevice;
